<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="基础信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{inspectionIncoming.billNo}}</td>
            <td class="tableLabel">检验员：</td>
            <td>{{inspectionIncoming.inspectorName}}</td>
            <td class="tableLabel">检验时间：</td>
            <td>{{inspectionIncoming.checkTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">送货单号：</td>
            <td>{{inspectionIncoming.deliveryNo}}</td>
            <td class="tableLabel">出厂编号：</td>
            <td>{{inspectionIncoming.factoryNo}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>{{inspectionIncoming.customerName}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">检验明细</div>
      <el-table
          height="39vh"
          :data="inspectionIncoming.inspectionReportVOS">
        <el-table-column prop="no" width="130" align="center" label="检验编号">
          <template slot-scope="scope">
            <span style="color: #2d8cf0; cursor: pointer" @click="$refs.editIncomingDetailPreview.open(scope.row,scope.$index)">{{scope.row.no}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialNo" width="90" align="center" label="物料编号"/>
        <el-table-column prop="mappingMaterialNo" width="90" align="center" label="旧物料号"/>
        <el-table-column prop="materialName" width="210" align="center" label="物料名称"/>
        <el-table-column prop="purchaseOrderNo" width="130" align="center" label="采购单号"/>
        <el-table-column prop="purchaseOrderRowNo" width="130" align="center" label="行号"/>
        <el-table-column prop="factoryNo" width="130" align="center" label="pc号"/>
        <el-table-column prop="submissionNum" align="center" label="送检数量"/>
        <el-table-column prop="spotCheckNum" align="center" label="抽检数量"/>
        <el-table-column prop="unqualifiedNum" align="center" label="抽检不合格数量"/>
        <el-table-column prop="badQuality" align="center" label="不良数量"/>
        <el-table-column prop="inspectionResult" align="center" width="160" label="检查结果">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.inspectionResult"
                disabled
                style="display: block"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="ok"
                inactive-text="ng"/>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
    <inspection-incoming-detail-preview ref="editIncomingDetailPreview"/>
  </div>
</template>

<script>
  import HandleDetail from "../../workFlow/HandleDetail.vue";
  import loginUtil from "@/util/loginUtil";
  import InspectionIncomingDetailPreview from "@/views/inspection/inspectionIncoming/InspectionIncomingDetailPreview";
  export default {
    name:"InspectionIncomingPreview",
    components:{InspectionIncomingDetailPreview, HandleDetail},
    data() {
      return {
        srcList:[],
        billId:"",
        billType:"23",
        pkid:"",
        saveLoading: false,
        imgUrls: [],
        appointmentItemTemplates1: [],
        appointmentItemTemplates2: [],
        inspectionIncoming: {
          pkid: 0,
          billNo: "",
          checkTime: "",
          voucherNo: "",
          factoryNo: "",
          purchaseOrderNo: "",
          deliveryNo: "",
          deliveryDate: "",
          supplierId: "",
          customerId: "",
          customerName: "",
          status: 0,
          supplierName: "",
          inspectorName: loginUtil.getName(),
          inspectionReportVOS: [],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.inspectionIncoming={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`incomings/${this.billId}`).then((res)=>{
          console.log(res);
          this.inspectionIncoming = res.data;
          this.inspectionIncoming.siteAttachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
        }).catch(()=>{
        });
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
    },
  };
</script>

<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
